import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import Switch from "@material-ui/core/Switch";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import { Trad } from "src/components";
import ChiamaWeb, {CChiamaWebParametri} from "src/ChiamaWeb";
import { IRouteParam } from "../../pages/Bond";
import { AlertDialogContext } from "../../providers/AlertDialogProvider";

interface ICheckFileListRowProps {
    File: Dati.CDatiFileCheckList;
    Index: number;
    OnFileChange: (name: string, val: any) => void;
    OnSelectedUpdate: (index: number, selected: boolean) => void;
}

export const _CheckFileListRow: React.FC<ICheckFileListRowProps> = ({ File, Index, OnFileChange, OnSelectedUpdate }) => {
    const { ID_Anag, ID_FideAffidamento, ID_Polizza } = useParams<IRouteParam>();
    const { ShowDialog } = useContext(AlertDialogContext);

    const session = Glob.GetSessione().Sessione;
    const isAdded = File.ID_File > 0;

    const ValidateFile = () => {
        const Param: CChiamaWebParametri = {
            URL: `/api/file/ValidaFile?sessione=${session}&id_file=${File.ID_File}&ID_Chiave=${ID_Polizza}&valida=${File.ID_TipoFileStato == Glob.Tipi_FS_Caricato}`,
            Metodo: "GET",
            OnRis: OnValidateFile,
            OnErrore: OnError
        };
        new ChiamaWeb().Chiama(Param);
    };

    const OnValidateFile = (sender: ChiamaWeb, data: any) => {
        if (data.Errore) {
            ShowDialog("ERRORE", data.ErrTesto, "error");
        } else {
            ShowDialog("SUCCESS", Trad.Trad("Documento validato correttamente"), "success");
            switch (File.ID_TipoFileStato) {
                case Glob.Tipi_FS_Caricato:
                    OnFileChange(`FileCaricati[${Index}].ID_TipoFileStato`, Glob.Tipi_FS_Validato);
                    OnSelectedUpdate(Index, true);
                    break;
                case Glob.Tipi_FS_Validato:
                    OnFileChange(`FileCaricati[${Index}].ID_TipoFileStato`, Glob.Tipi_FS_Caricato);
                    OnSelectedUpdate(Index, false);
                    break;
            }
        }
    };

    const OnError = (sender: ChiamaWeb, error: Error) => {
        ShowDialog("ERRORE", error.message, "error");
    };

    return (
        <TableRow>
            <TableCell align="center">
                <Link href={`/file/${ID_Polizza}${File.ID_File}`}>
                    <Tooltip title={Trad.Trad("Modifica")}>
                        <IconButton aria-label="edit" size="small">
                            {isAdded ? <InsertDriveFileIcon /> : <AddIcon />}
                        </IconButton>
                    </Tooltip>
                </Link>
            </TableCell>
            <TableCell>{File.Tipo}</TableCell>
            <TableCell>
                {isAdded && (
                    <Link href={`/api/file/scarica?id_file=${File.ID_File}&sessione=${session}`} target="_blank">
                        {File.NomeFile}
                    </Link>
                )}
            </TableCell>
            <TableCell>
                {isAdded && (
                    <FormControlLabel
                        control={<Switch checked={File.ID_TipoFileStato == Glob.Tipi_FS_Validato} onChange={ValidateFile} name="ID_TipoFileStato" size="small" />}
                        label={Trad.Trad("Validato")}
                    />
                )}
            </TableCell>
            <TableCell>
                <FormControlLabel control={<Checkbox checked={File.Selezionato} onChange={e => OnSelectedUpdate(Index, e.currentTarget.checked)} name="" />} label={Trad.Trad("Selezionato")} />
            </TableCell>
        </TableRow>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/CheckFileList/CheckFileListRow.tsx